<!-- Small top-centre overlay telling the reader what the viewer is still loading (image tiles
     and/or annotations), each with a spinner. Driven by the tile loader and the annotation fetch
     lifecycle in CytomineImage. Purely informative: it never intercepts pointer events.
     Ported from zaya-ims web-ui/src/components/viewer/LoadingIndicatorOverlay.vue. -->
<template>
<div v-if="tilesLoading || annotationsLoading" class="loading-indicator">
  <div v-if="tilesLoading" class="li-row">
    <i class="fas fa-circle-notch fa-spin li-spin"></i>
    <span>{{ $t('tiles-loading') }}</span>
  </div>
  <div v-if="annotationsLoading" class="li-row">
    <i class="fas fa-circle-notch fa-spin li-spin"></i>
    <span>{{ $t('annotations-loading') }}</span>
  </div>
</div>
</template>

<script>
export default {
  name: 'loading-indicator-overlay',
  props: {
    tilesLoading: {type: Boolean, default: false},
    annotationsLoading: {type: Boolean, default: false}
  }
};
</script>

<style scoped>
.loading-indicator {
  position: absolute;
  top: 3.4rem; /* below the drawing toolbar */
  left: 50%;
  transform: translateX(-50%);
  z-index: 28;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #e5e8ee;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(15, 17, 22, 0.12);
  padding: 7px 12px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  pointer-events: none;
}
.li-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
}
.li-spin {
  color: #1e63d0;
  font-size: 12px;
}
</style>
